import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7624b6ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-binding" }
const _hoisted_2 = { class: "owner" }
const _hoisted_3 = { class: "steps" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "→", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "验证账号已登记的手机号", -1))
const _hoisted_6 = { class: "sms-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "已有账号不会重复注册。", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "短信验证通过，请使用本人微信扫码", -1))
const _hoisted_9 = {
  key: 0,
  class: "qr-demo"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "✓ 当前账号已绑定微信", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下次可使用微信扫码登录。", -1))
const _hoisted_12 = {
  key: 3,
  class: "error",
  role: "alert"
}
const _hoisted_13 = { key: 4 }

import {captureOperationFeedback} from '@/utils/operationFeedback'

import {ref,watch,onBeforeUnmount} from 'vue'
import wxlogin from 'vue-wxlogin'
import store from '@/store'
import request from '@/utils/request'
import sysRequest from '@/api/sys'
import {createWechatLoginState} from '@/utils/wechatLoginState'

export default /*#__PURE__*/_defineComponent({
  __name: 'InlineWechatBinding',
  props: {
    visible: { type: Boolean },
    orgName: {},
    currentScope: {},
    preview: { type: Boolean }
  },
  emits: ['close','bound','authenticated','completed'],
  setup(__props: any, { emit: __emit }) {

const props=__props
const emit=__emit
const step=ref('sms'),phone=ref(''),code=ref(''),error=ref(''),state=ref(''),busy=ref(false),sending=ref(false),locked=ref(false),seconds=ref(0)
const appid=process.env.VUE_APP_APPID
const redirectUri=encodeURIComponent(process.env.VUE_APP_WXBINDING_URL || String(process.env.VUE_APP_LOGIN_URL || '').replace(/receiveCode$/, 'receiveCodeForBinding'))
const customer=()=>props.currentScope!=='管理端'
const snapshot=()=>({token:String(store.getters.token||''),id:Number(store.getters.token?store.getters.userInfo?.id||0:0),orgId:Number(customer()?store.getters.orgId:store.getters.userInfo?.orgId||0)})
let smsTicket="",generation=0,owner=snapshot(),expiry=0,checking=false
let countdown:ReturnType<typeof setInterval>|undefined,poll:ReturnType<typeof setInterval>|undefined
function stop(){clearInterval(countdown);clearInterval(poll);countdown=undefined;poll=undefined;checking=false}
function current(run:number){return props.visible && run===generation && JSON.stringify(owner)===JSON.stringify(snapshot())}
function close(){generation++;stop();code.value='';state.value='';emit('close')}
watch(()=>props.visible,(open)=>{generation++;stop();busy.value=false;sending.value=false;seconds.value=0;code.value='';state.value='';error.value='';step.value='sms';owner=snapshot();const user=store.getters.userInfo;phone.value=owner.token?String(customer()?user?.cellphone||'':user?.phone||''):'';locked.value=!!owner.token && /^1[3-9]\d{9}$/.test(phone.value)},{immediate:true})
watch(()=>JSON.stringify(snapshot()),()=>{if(props.visible&&!busy.value){generation++;stop();state.value='';step.value='sms';error.value='账号或店铺已变化，请关闭后重新验证'}})
async function send(){const reportOperationIssue=captureOperationFeedback();
  if(sending.value||busy.value||seconds.value)return
  if(!/^1[3-9]\d{9}$/.test(phone.value)){{error.value='请输入正确的手机号码';reportOperationIssue(error.value)}return}
  const run=generation;error.value='';sending.value=true
  try{
    if(!props.preview){const result=await sysRequest.sendValideCode(phone.value,createWechatLoginState().substring(0,8));if(!current(run))return;if(Number(result.data)!==1)throw new Error('验证码发送失败，请核对账号手机号后重试')}
    if(!current(run))return
    seconds.value=60;countdown=setInterval(()=>{if(seconds.value>0)seconds.value--;if(!seconds.value)clearInterval(countdown)},1000)
  }catch(e:any){if(current(run)){error.value=e?.message||'短信发送失败，请重试';reportOperationIssue(error.value)}}finally{if(run===generation)sending.value=false}
}
async function verify(){const reportOperationIssue=captureOperationFeedback();
  if(busy.value||sending.value)return
  if(!/^1[3-9]\d{9}$/.test(phone.value)||!/^\d{6}$/.test(code.value)){{error.value='请输入正确的手机号和6位短信验证码';reportOperationIssue(error.value)}return}
  const run=generation;busy.value=true;error.value=''
  try{
    if(!current(run))throw new Error('账号或店铺已变化，请重新打开窗口')
    if(!props.preview){
      const data=await store.dispatch('user/codeLogin',{phone:phone.value,code:code.value,autoRegister:false,bindingContext:{...owner,customer:customer(),valid:()=>current(run)}})
      if(!props.visible||run!==generation)return
      if(!data)throw new Error('短信验证未通过，请核对验证码后重试')
      owner=snapshot();smsTicket=String(data.wechatBindingState||'');emit('authenticated',data)
    }
    if(!current(run))return
    code.value='';step.value='wechat';await createQr()
  }catch(e:any){if(run===generation){error.value=e?.message||'验证失败，请重试';reportOperationIssue(error.value)}}finally{if(run===generation)busy.value=false}
}
function refreshQr(){if(customer()){void createQr();return}clearInterval(poll);state.value='';smsTicket='';code.value='';step.value='sms';error.value=''}
async function createQr(){const reportOperationIssue=captureOperationFeedback();
  const run=generation;clearInterval(poll);state.value='';error.value=''
  if(props.preview)return
  busy.value=true
  try{
    if(!current(run))throw new Error('账号或店铺已变化，请重新验证')
    const result=customer()?await request({url:'customer/wechatBindingState',method:'POST'}):{data:{state:smsTicket}}
    if(!current(run))return
    if(!/^WB_[a-f0-9]{32}$/.test(result.data?.state||''))throw new Error('微信绑定授权生成失败，请重试')
    state.value=result.data.state;expiry=Date.now()+300000;poll=setInterval(checkBinding,3000)
  }catch(e:any){if(run===generation){error.value=e?.message||'二维码加载失败，请重新生成';reportOperationIssue(error.value)}}finally{if(run===generation)busy.value=false}
}
async function checkBinding(){
  if(checking||document.visibilityState==='hidden')return
  if(Date.now()>=expiry){clearInterval(poll);state.value='';error.value='二维码已过期，请重新生成';return}
  const run=generation;if(!current(run))return;checking=true
  try{const result=await request({url:(customer()?'customer':'system')+'/wechatLoginBindingStatus',method:'GET',quietNotification:true} as any);const status=result.data;if(current(run)&&status?.bound===true&&Number(status.accountId)===owner.id&&Number(status.orgId)===Number(store.getters.userInfo?.orgId)&&status.role===(customer()?'cus':'org'))complete()}catch{/* 短暂断网保留二维码，下一次轮询恢复。 */}finally{if(run===generation)checking=false}
}
function complete(){clearInterval(poll);step.value='done';emit('bound');if(!props.preview)window.dispatchEvent(new Event('wechat-login-binding-changed'))}
onBeforeUnmount(()=>{generation++;stop()})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: "绑定微信",
    footer: null,
    width: 480,
    centered: "",
    "mask-closable": false,
    onCancel: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.currentScope==='管理端'?'管理端账号':_ctx.orgName+' · 客户账号'), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass({active:step.value==='sms'})
          }, "短信验证", 2),
          _hoisted_4,
          _createElementVNode("span", {
            class: _normalizeClass({active:step.value!=='sms'})
          }, "绑定微信", 2)
        ]),
        (step.value==='sms')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_5,
              _createVNode(_component_a_input, {
                "data-operation-error-pattern": "请输入正确的手机号码|请输入正确的手机号和",
                "data-operation-error-label": "手机号码",
                value: phone.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
                disabled: locked.value || busy.value || sending.value,
                size: "large",
                maxlength: "11",
                inputmode: "tel",
                placeholder: "请输入手机号码",
                "aria-label": "绑定账号的手机号"
              }, null, 8, ["value", "disabled"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_input, {
                  "data-operation-error-pattern": "6位短信验证码|请输入.*验证码",
                  "data-operation-error-label": "短信验证码",
                  value: code.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((code).value = $event)),
                  disabled: busy.value,
                  size: "large",
                  maxlength: "6",
                  inputmode: "numeric",
                  placeholder: "请输入短信验证码",
                  "aria-label": "短信验证码"
                }, null, 8, ["value", "disabled"]),
                _createVNode(_component_a_button, {
                  disabled: busy.value || sending.value || seconds.value>0,
                  loading: sending.value,
                  onClick: send
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(seconds.value>0?seconds.value+'秒后重发':'获取验证码'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _hoisted_7,
              _createVNode(_component_a_button, {
                type: "primary",
                size: "large",
                block: "",
                loading: busy.value,
                disabled: sending.value,
                onClick: verify
              }, {
                default: _withCtx(() => [
                  _createTextVNode("验证并继续绑定")
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ], 64))
          : (step.value==='wechat')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_8,
                (_ctx.preview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createTextVNode("微信二维码区域 · 本地模拟，不进行真实授权"),
                      _createVNode(_component_a_button, { onClick: complete }, {
                        default: _withCtx(() => [
                          _createTextVNode("模拟绑定成功")
                        ]),
                        _: 1
                      })
                    ]))
                  : (state.value)
                    ? (_openBlock(), _createBlock(_unref(wxlogin), {
                        key: state.value,
                        appid: _unref(appid),
                        scope: "snsapi_login",
                        state: state.value,
                        self_redirect: "true",
                        redirect_uri: _unref(redirectUri)
                      }, null, 8, ["appid", "state", "redirect_uri"]))
                    : _createCommentVNode("", true),
                _createVNode(_component_a_button, {
                  loading: busy.value,
                  onClick: refreshQr
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer()?"重新生成二维码":"重新短信验证"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_10,
                _hoisted_11,
                _createVNode(_component_a_button, {
                  type: "primary",
                  block: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {close();_ctx.$emit('completed')})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("完成")
                  ]),
                  _: 1
                })
              ], 64)),
        (error.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true),
        (_ctx.preview)
          ? (_openBlock(), _createElementBlock("small", _hoisted_13, "模拟验证：不发送短信、不改动账号、不进行真实绑定。"))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})